import styled from "styled-components";

export default styled.div.attrs(props => ({
	id: props.id
}))`
	width: 90%;
	max-width: ${props => props.maxwidth || "690px"};
	align-items: ${props => props.align || "center"};
	align-content: ${props => props.aligncontent || "center"};
	flex-direction: ${props => props.flexdirection || "row"};
	display: ${props => props.display || "flex"};
	flex-wrap: wrap;
	justify-content: ${props => props.justifyContent};
	margin-top: ${props => props.margintop || "0"};
	margin-bottom: ${props => props.marginbottom};
	margin-right: ${props => props.marginright};
	margin-left: ${props => props.marginleft};
	padding-right: ${props => props.paddingright};
`;
